export interface NupCopy {
  rules: string;
  enrollNow: string;
  depositNow: string;
  deposit: string;
  chooseThis: string;
  chooseReward: string;
  view: string;
  heroAlt: string;
  entryTitle: string;
  entryDesc: string;
  guaranteed: string;
  advancedTitle: string;
  advancedDesc: string;
  titleDefault: string;
  titleAwarded: string;
  titleMissed: string;
  subDefaultH5: string;
  subDefaultPc: string;
  subMissed: string;
  countdownH5: string;
  countdownPc: string;
  confirmTitle: string;
  confirmDesc: string;
  thinkAgain: string;
  confirm: string;
  close: string;
  enrollSuccessTitle: string;
  enrollSuccessDesc: string;
  choiceSuccessAlt: string;
  awardedAlt: string;
  missedAlt: string;
  rulesSoon: string;
  loadFailed: string;
  opFailed: string;
  udpMiss: string;
  enrollEnded: string;
  statusNotAllowed: string;
  choiceNotAllowed: string;
  invalidChoice: string;
  awardedPrefix: string;
  awardedPrefixEmpty: string;
  terms: readonly string[];
}

export const COPY_ZH: NupCopy = {
  rules: '活動規則',
  enrollNow: '立即報名',
  depositNow: '立即入資',
  deposit: '去入資',
  chooseThis: '我選這個',
  chooseReward: '選擇獎賞',
  view: '查看',
  heroAlt: '人人享迎新獎賞 高達 $100,000',
  entryTitle: '入門賞',
  entryDesc: '存入資金$10,000',
  guaranteed: '可額外疊加進階賞',
  advancedTitle: '進階賞',
  advancedDesc:
    '活動期累計淨入資達指定檔位並完成留存任務，即可額外獲得進階獎賞。獎賞按報名後第15日截止時的淨入資所達檔位發放。',
  titleDefault: '入資越多 「賞」頭越大',
  titleAwarded: '恭喜您 獲得獎賞',
  titleMissed: '感謝支持',
  subDefaultH5: '15天限時入資拎獎賞',
  subDefaultPc: '15天內累計淨入資達標，即享相應檔位獎賞',
  subMissed: '您的累計淨入資未達標',
  countdownH5: '內累計淨入資達標，拎獎賞',
  countdownPc: '內累計淨入資達標，即享相應檔位獎賞',
  confirmTitle: '確認選擇該獎賞嗎？',
  confirmDesc: '選擇後不可更改',
  thinkAgain: '再想想',
  confirm: '確認',
  close: '關閉',
  enrollSuccessTitle: '報名成功',
  enrollSuccessDesc: '15天內累計入資達標，享10萬酬賓賞',
  choiceSuccessAlt: '選擇成功',
  awardedAlt: '已獲得獎賞',
  missedAlt: '感謝支持',
  rulesSoon: '活動規則即將公布',
  loadFailed: '加載失敗，請稍後再試',
  opFailed: '操作失敗，請稍後再試',
  udpMiss: '暫不符合參加條件',
  enrollEnded: '報名已截止',
  statusNotAllowed: '當前狀態無法報名',
  choiceNotAllowed: '入金期已結束，無法更換獎賞',
  invalidChoice: '獎賞選項無效',
  awardedPrefix: '您的累計淨入資达標',
  awardedPrefixEmpty: '您的累計淨入資达標',
  terms: [
    '受活動條款及細則約束。',
    '入門賞 HK$1萬檔可與進階賞疊加領取；進階賞內各檔位互斥，用戶僅可獲取達標的最高進階檔位，不可同時獲得多個進階賞檔位。',
    '進階賞按「報名」後15天截止淨入金所達到的檔位發放；HK$1萬檔、HK$8萬檔須留存60日；HK$15萬或以上檔須留存270日並每30日分批解鎖。',
    '留存期內日均資產維持不得低於相應門檻，否則未解鎖獎賞將失效，亦不可獲得其他檔位獎勵。',
    'HK$1萬檔和HK$8萬檔均能選擇一個獎勵，已報名但未選獎勵者默認選擇英偉達（NASDAQ：NVDA）。',
    '*實際贈股發放數量將根據解凍日的收市價進行計算，贈幣發放需開通現金綜合賬戶-加密貨幣。',
    '^匯豐贈股價值按2026年6月30日的收市價預估, 股票價值取至最近個位數。 實際匯豐贈股的發放金額以領取獎勵前一日的收市價進行計算。',
  ],
};

export const COPY_EN: NupCopy = {
  rules: 'Terms&Rules',
  enrollNow: 'Join Now',
  depositNow: 'Deposit Now',
  deposit: 'Deposit',
  chooseThis: 'Claim Now',
  chooseReward: 'Claim Now',
  view: 'View',
  heroAlt: 'Welcome Rewards up to $100,000',
  entryTitle: 'Standard Reward',
  entryDesc: 'Deposit $10,000',
  guaranteed: 'Eligible for Premium Reward',
  advancedTitle: 'Premium Reward',
  advancedDesc:
    'Accumulate deposits to earn an additional Premium Reward based on your deposit tier.\nYour tier is determined by your total deposits as of Day 15. Complete the required tasks to unlock your reward.',
  titleDefault: 'Maximize Your\nWelcome Rewards',
  titleAwarded: 'Congratulations! You’ve\nearned your rewards!',
  titleMissed: 'Thank you for your support',
  subDefaultH5: 'Unlock higher reward tiers based on your 15-day net deposits.',
  subDefaultPc: 'Unlock higher reward tiers based on your 15-day net deposits.',
  subMissed: 'Your net deposits did not reach the required tier',
  countdownH5: ' left to reach net deposit targets and unlock premium rewards.',
  countdownPc: ' left to reach net deposit targets and unlock premium rewards.',
  confirmTitle: 'Confirm this reward?',
  confirmDesc: 'Your selection cannot be changed.',
  thinkAgain: 'Later',
  confirm: 'Confirm',
  close: 'Close',
  enrollSuccessTitle: 'Registration Successful',
  enrollSuccessDesc:
    'Deposit the required amount within 15 days to claim up to $100,000 in rewards.',
  choiceSuccessAlt: 'Choice confirmed',
  awardedAlt: 'Reward awarded',
  missedAlt: 'Thank you for your support',
  rulesSoon: 'Campaign rules coming soon',
  loadFailed: 'Failed to load. Please try again later',
  opFailed: 'Something went wrong. Please try again later',
  udpMiss: 'You are not eligible for this campaign',
  enrollEnded: 'Enrollment has ended',
  statusNotAllowed: 'Unable to enroll in the current status',
  choiceNotAllowed: 'The deposit period has ended. Reward cannot be changed',
  invalidChoice: 'Invalid reward option',
  awardedPrefix: 'Your cumulative net deposit has reached ',
  awardedPrefixEmpty:
    'Your cumulative net deposit has reached the required tier',
  terms: [
    'Terms and conditions apply. Rewards are issued based on the highest net deposit tier reached within 15 days after registration. Tiers are mutually exclusive and cannot be combined.',
    'The HK$10,000 & HK$80,000 tiers require a 60-day holding period; tiers of HK$150,000 or above require a 270-day holding period, with rewards unlocked in batches every 30 days. During the holding period, your average daily assets must not fall below the corresponding threshold. Otherwise, any remaining locked rewards will be forfeited, and you will not be eligible for rewards from other tiers.',
    'For the HK$10,000 & HK$80,000 tiers, you should select one reward for both tiers. Registered users who do not select a reward will receive Nvidia (NASDAQ: NVDA) shares by default.',
    '*The quantity of gift shares and crypto you receive will be determined by the closing price on the day they are unlocked. A Universal Account - Crypto is required to receive gift shares and crypto.',
    '^Value of HSBC shares based on closing price as of June 30, 2026, rounded to the nearest dollar.',
  ],
};

export function getCopy(isEn: boolean): NupCopy {
  return isEn ? COPY_EN : COPY_ZH;
}
